import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import AnaSayfa from './pages/AnaSayfa';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import IsletmeMenu from './pages/IsletmeMenu';
import IsletmeLogin from './pages/IsletmeLogin';
import IsletmePanel from './pages/IsletmePanel';
import GlobalGiris from './pages/GlobalGiris';
import YeniHesap from './pages/YeniHesap';
import SablonOnizleme from './pages/SablonOnizleme';
import DinamikManifest from './DinamikManifest';

function App() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <DinamikManifest />
      <Routes>
        <Route path="/" element={<AnaSayfa />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/giris" element={<GlobalGiris />} />
        <Route path="/yeni-hesap" element={<YeniHesap />} />
        <Route path="/sablon-onizleme/:id" element={<SablonOnizleme />} />
        <Route path="/:slug" element={<IsletmeMenu />} />
        <Route path="/:slug/ayarlar" element={<IsletmeLogin />} />
        <Route path="/:slug/ayarlar/panel" element={<IsletmePanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
